import React from 'react';
import Image from '../../components/common/Image';
import { decode } from 'html-entities';
import { ICategoryBanner } from '../../utils/types/taxonomy';

export default function Banner(props: ICategoryBanner) {
    const { description, sourceUrl, name, bannerText } = props;
    return (
        <div>
            {/* Hero card */}
            <div className="relative">
                <div className="absolute inset-x-0 bottom-0 h-1/2 " />
                <div className="mx-auto max-w-full">
                    <div className="relative sm:overflow-hidden h-[300px]">
                        <div className="absolute inset-0">
                            <Image
                                fill
                                blur={false}
                                priority
                                src={sourceUrl}
                                alt={name}
                                className="h-full w-full object-cover"
                                sizes="100vw"
                            />
                            <div className="absolute inset-0 bg-gray-300 mix-blend-multiply" />
                        </div>
                        <div className="relative px-4 py-16 xl:py-24 xl:px-72 flex items-center justify-center h-full">
                            <div className="container">
                                <h2 className="text-center text-black text-xl xl:text-2xl font-bold  italic font-playfairdisplay pb-2">{decode(bannerText)}</h2>
                                <h1 className="xl:max-w-3xl mx-auto text-center text-white text-4xl xl:text-4.5xl font-black  font-playfairdisplay text-shadow leading-[150%] uppercase">
                                    {decode(name)}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
